import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class AngieCustomersService extends RestfulService<Models.AngieCustomer> {

  constructor(public restService: RestService) {
    super(Models.AngieCustomer);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('angie-customers');
  }

}
